function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.8261 12.2174C21.7826 12.2174 22.5566 11.4348 22.5566 10.4782L22.5653 1.78259C22.5653 0.826066 21.7826 0.043457 20.8261 0.043457H6.91308C5.95655 0.043457 5.17394 0.826066 5.17394 1.78259V10.4782C5.17394 11.4348 5.95655 12.2174 6.91308 12.2174H3.43481V13.9565H24.3044V12.2174H20.8261ZM6.91308 1.78259H20.8261V10.4782H6.91308V1.78259Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0435 2.15234H9.5435V2.65234V13.9567V14.4567H10.0435H12.1305H12.6305V13.9567V2.65234V2.15234H12.1305H10.0435ZM1.69568 9.21756H1.19568V9.71756V13.9567V14.4567H1.69568H3.78264H4.28264V13.9567V9.71756V9.21756H3.78264H1.69568ZM5.86959 5.68495H5.36959V6.18495V13.9567V14.4567H5.86959H7.95655H8.45655V13.9567V6.18495V5.68495H7.95655H5.86959Z",
  stroke: "#F1F2F5"
});

var SvgLaptopChartIcon = function SvgLaptopChartIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 15,
    viewBox: "0 0 25 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLaptopChartIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/laptop-chart-icon.d8f64c13.svg";
export { ForwardRef as ReactComponent };